@if (visible()) {
<div> <!-- class="jk-numberedit-border" -->
  <div [ngStyle]="flexStyle" class="items-center">
    <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
      [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
    <button class="btn-normal  jk-edit-button" (click)="decrement()">
      <mat-icon class="jk-edit-button__icon">remove</mat-icon>
    </button>
    <input matInput class="jk-numberedit" type="number" [ngStyle]="widthStyle" [min]="min()" [max]="max()"
      style="width: 100%" (input)="onValueChange($event)" [disabled]="disabled()" [readonly]="readonly()"
      [required]="required()" [(ngModel)]="value" />
    <button class="btn-normal jk-edit-button" (click)="increment()">
      <mat-icon class="jk-edit-button__icon">add</mat-icon>
    </button>

  </div>
</div>
}
